import { useEffect } from 'react';
import { Route, RouteProps, Routes, useNavigate } from 'react-router';
import { useAppStorage, useObservable } from '@aesop-fables/scrinium';
import TopNavBar from '../components/TopNavBar';
import { AboutYourOrg, ChooseProduct, License, Contract } from '../sign-up/index';

import * as Style from '../dashboard/main/style';
import AdpContract from '../sign-up/Adp/AdpContract';
import AdpOnboarding from '../sign-up/Adp/AdpOnboarding';
import { RestrictMemberAccess } from '../dashboard';
import InviteOtherAdmins from '../sign-up/InviteOtherAdmins';
import AddMembersBulk from '../dashboard/members/AddMembersBulk';
import { NavigatedFromBulkAddProvider } from '../hooks/useNavigatedFromBulkAdd';
import { SignUpCompartments, signUpStorageKey } from '../data/signUp';
import { OrgSignUpStateData } from '../models/SignUpData';
import { Loading } from './AuthenticatedRoutes';

const OnboardingRoutes: React.FC<RouteProps> = () => {
  const navigate = useNavigate();
  const appStorage = useAppStorage();
  const signUpDataCache = appStorage.retrieve<SignUpCompartments>(signUpStorageKey);
  const orgSignUpStateInitialized = useObservable(
    signUpDataCache.findCompartment('orgSignUpState').initialized$,
  );
  const orgSignUpState = useObservable(
    signUpDataCache.observe$<OrgSignUpStateData>('orgSignUpState'),
  );
  const onboardingAlreadyComplete = Boolean(
    orgSignUpStateInitialized && orgSignUpState?.onboardingComplete,
  );

  useEffect(() => {
    if (onboardingAlreadyComplete) {
      navigate('/', { replace: true });
    }
  }, [onboardingAlreadyComplete, navigate]);

  if (onboardingAlreadyComplete) {
    return <Loading />;
  }

  return (
    <Style.MainWrapper>
      <Style.MainLayout>
        <TopNavBar hideProfile useDrillDownCrumbs />
        <Style.MainSection>
          <Style.MainContentRight>
            <NavigatedFromBulkAddProvider>
              <Routes>
                <Route path='/aboutYourOrg' element={<AboutYourOrg />} />
                <Route path='/adpContract' element={<AdpContract />} />
                <Route path='/adpDeductions' element={<AdpOnboarding />} />
                <Route path='/chooseProduct' element={<ChooseProduct />} />
                <Route path='/contract' element={<Contract />} />
                <Route path='/inviteOtherAdmins' element={<InviteOtherAdmins />} />
                <Route path='/license' element={<License />} />
                <Route path='/restrictMembers' element={<RestrictMemberAccess />} />
                <Route path='/restrictMembers/add' element={<AddMembersBulk />} />
              </Routes>
            </NavigatedFromBulkAddProvider>
          </Style.MainContentRight>
        </Style.MainSection>
      </Style.MainLayout>
    </Style.MainWrapper>
  );
};

export default OnboardingRoutes;
